<template>
  <section class="animate-rise" data-testid="lose-view">
    <h2 class="text-center font-display text-3xl font-semibold text-neutral-900">
      {{ t('lose-view.heading') }}
    </h2>
    <PlayerCard :player="store.player" />
    <div
      class="mt-6 flex flex-col items-center gap-4 sm:flex-row sm:justify-center"
    >
      <button
        class="btn-primary w-full sm:w-auto"
        type="button"
        :disabled="store.loading"
        @click="handleRetry"
        data-testid="retry"
      >
        <span v-if="store.loading">{{ t('common.loading') }}</span>
        <span v-else>{{ t('lose-view.button-retry') }}</span>
      </button>
      <button
        class="btn-secondary w-full sm:w-auto"
        type="button"
        @click="handleChangeParameters"
        data-testid="change-parameters"
      >
        {{ t('common.change-parameters') }}
      </button>
      <!-- <button
        class="btn-secondary w-full sm:w-auto"
        type="button"
        @click="handleChallengeFriend"
        data-testid="challenge-friend"
      >
        {{ t('common.challenge-friend') }}
      </button> -->
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useGameStore } from "../stores/game";
import { parseSeasonLabel } from "../utils/season";
import PlayerCard from "../components/PlayerCard.vue";
import { useText } from "../composables/useText.js";

const router = useRouter();
const store = useGameStore();
const { t } = useText();
const shareStatus = ref("");

const buildGameRoute = () => {
  const playerId = store.player?.id;
  if (!playerId) return null;

  const mode = store.gameModeSelection || "career";
  if (mode === "photo") {
    return { name: "photo", params: { playerId } };
  }

  if (mode === "stats") {
    const seasonLabel = store.season;
    const parsedSeason = parseSeasonLabel(seasonLabel);
    const seasonParam = Number.isNaN(parsedSeason)
      ? String(seasonLabel || "")
      : String(parsedSeason);
    if (!seasonParam) {
      return { name: "data", params: { playerId } };
    }
    return { name: "one-year", params: { playerId, season: seasonParam } };
  }

  return { name: "data", params: { playerId } };
};

const handleRetry = async () => {
  try {
    await store.startGame(
      store.leagueSelection,
      store.seasonSelection,
      store.teamId,
    );
    const routeTarget = buildGameRoute();
    if (!routeTarget) {
      throw new Error(t('form.error-load-player'));
    }
    router.push(routeTarget);
  } catch (error) {
    // error state handled in store
  }
};

const handleChangeParameters = () => {
  router.push({ name: "form" });
};

const handleChallengeFriend = async () => {
  shareStatus.value = "";
  if (!navigator.share) {
    shareStatus.value = t('common.share-unsupported');
    return;
  }

  const playerId = store.player?.id;
  if (!playerId) {
    shareStatus.value = t('common.share-error');
    return;
  }

  try {
    const resolved = router.resolve({
      name: "data",
      params: {
        playerId,
      },
    });
    const shareUrl = new URL(resolved.href, window.location.origin).toString();
    await navigator.share({
      title: t('common.app-name'),
      url: shareUrl,
    });
  } catch (error) {
    if (error?.name === "AbortError") return;
    shareStatus.value = t('common.share-error');
  }
};
</script>
